import { French } from "flatpickr/dist/l10n/fr";
import { German } from "flatpickr/dist/l10n/de";

const LOCALES = {
  fr: French,
  de: German,
};

const ALT_FORMATS_BY_LOCALE = {
  fr: "d F Y",
  de: "d. F Y",
};

const DEFAULT_LOCALE_ISO = "fr";

export const getLocale = (localeIso) => {
  return LOCALES[localeIso] || LOCALES[DEFAULT_LOCALE_ISO];
};

export const getAltFormat = (localeIso) => {
  return (
    ALT_FORMATS_BY_LOCALE[localeIso] ||
    ALT_FORMATS_BY_LOCALE[DEFAULT_LOCALE_ISO]
  );
};

export const clearDisable = (fp, maxWeeks = undefined) => {
  if (fp.selectedDates.length === 1) {
    fp.config.disable.pop();
    if (maxWeeks !== undefined && maxWeeks !== null) {
      fp.config.disable.pop();
    }
  }
};
